import reduce from 'lodash/reduce';
import isString from 'lodash/isString';
import isNumber from 'lodash/isNumber';
import isArray from 'lodash/isArray';

export default query => reduce(Object.keys(query), (queryTaxonomyList, filterType) => {
	let filterList = [];

	if (isArray(query[filterType])) {
		filterList = query[filterType].map(slug => ({
			_type: filterType,
			slug,
		}));
	} else if (isString(query[filterType]) || isNumber(query[filterType])) {
		filterList = [{
			_type: filterType,
			slug: query[filterType],
		}];
	}
	
	return [
		...queryTaxonomyList,
		...filterList,
	];
}, []);